export default {
  label: {
    userName: '{name}的个人主页（ID: {id}）'
  },
  btn: {
    activeEmployee: '立刻激活！'
  },
  message: {
    activeEmployeeTip: '您的员工身份尚未被确认，点击这里',
    activeEmployee: {
      success: '我们已发送验证邮件到该邮箱，点击邮件链接，员工帐号会自动激活。',
      fail: '您的员工身份暂时不能激活，请联系您公司的HR。'
    }
  }
}
